import { render } from "./EditProfile.vue?vue&type=template&id=1dda91d0&scoped=true&ts=true"
import script from "./EditProfile.vue?vue&type=script&lang=ts"
export * from "./EditProfile.vue?vue&type=script&lang=ts"

import "./EditProfile.vue?vue&type=style&index=0&id=1dda91d0&lang=sass&scoped=true"
import "./EditProfile.vue?vue&type=style&index=1&id=1dda91d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dda91d0"]])

export default __exports__